import { QueryDispatcher } from "../../shared/domain/QueryDispatcher";

export class CheckContractExistsQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
  ) {}

  async run(contract_id: number, user_id?: number, user_username?: string ): Promise<{ exists: boolean; contract_id: number; kind?: string; user_id?: number }> {
    let args: any = {
      contract_id: contract_id,
      user_id: user_id,
      user_username:user_username
    }
    try {
      const result = await this.dispatcher.dispatch('check.contract.exists', args);
      return result as { exists: boolean; contract_id: number; kind?: string; user_username?: string };
    } catch(error) {
      console.error('Error al verificar si el contrato existe', error)
      throw error;
    }
  }
}
